<script>
export default {
  data() {
    return {};
  },
  methods: {
    submitForm() {
      this.$router.push("/");
    },
  },
};
</script>
<template>
  <div class="authentication-page">
    <div class="d-flex justify-content-between vh-100 overflow-auto flex-column">
      <!-- Header -->
      <div class="authentication-header">
        <div class="container">
          <div class="col-md-12">
            <div class="text-center">
              <img src="@/assets/img/logo.svg" alt="logo" />
            </div>
          </div>
        </div>
      </div>
      <!-- /Header -->

      <!-- Main Wrapper -->
      <div class="main-wrapper">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-5 mx-auto">
              <form @submit.prevent="submitForm">
                <div class="d-flex flex-column justify-content-center">
                  <div class="card p-sm-4 my-5">
                    <div class="card-body">
                      <div class="text-center mb-3">
                        <h3 class="mb-2">Start your free trial</h3>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Company Name</label>
                        <input type="text" class="form-control" />
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Domain</label>
                        <input type="text" class="form-control" />
                      </div>
                      <div class="mb-3">
                        <div class="row">
                          <div class="col-md-6">
                            <div>
                              <label class="form-label">First Name</label>
                              <input type="text" class="form-control" />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div>
                              <label class="form-label">Last Name</label>
                              <input type="text" class="form-control" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Work Email</label>
                        <input type="text" class="form-control" />
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Password</label>
                        <input type="text" class="form-control" />
                      </div>
                      <div class="mb-0">
                        <button type="submit" class="btn btn-lg btn-linear-primary w-100">
                          Register
                        </button>
                      </div>
                    </div>
                    <div>
                      <img
                        src="@/assets/img/bg/authentication-bg.png"
                        class="bg-left-top"
                        alt="Img"
                      />
                      <img
                        src="@/assets/img/bg/authentication-bg.png"
                        class="bg-right-bottom"
                        alt="Img"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- /Main Wrapper -->

      <!-- Footer -->
      <div class="footer-copyright bg-transparent">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <p>Copyright &copy; 2024. All Rights Reserved Truelysell</p>
            </div>
          </div>
        </div>
      </div>
      <!-- /Footer -->
    </div>

    <div class="back-to-top">
      <a
        class="back-to-top-icon align-items-center justify-content-center d-flex"
        href="#top"
        ><i class="fa-solid fa-arrow-up"></i
      ></a>
    </div>

    <!-- Cursor -->
    <div class="xb-cursor tx-js-cursor">
      <div class="xb-cursor-wrapper">
        <div class="xb-cursor--follower xb-js-follower"></div>
      </div>
    </div>
    <!-- /Cursor -->
  </div>
</template>
